import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { BranchSettingsResponseDto } from "../../shared/dtos/branchSettings/BranchSettingsResponseDto";
import { ServerStatusPayload } from "../../shared/interfaces/ServerStatusPayload";
import { UserDefaults } from "../../shared/interfaces/UserDefaults";

export const FACTORY_USER_DEFAULTS: UserDefaults = {
  paymentMode: null,
  itemType: null,
  taxCode: null,
  packageUnit: null,
  quantityUnit: null,
  categoryId: null,
  brandId: null,
};

export interface SettingsState {
  branchSettings: BranchSettingsResponseDto | null;
  loadingBranchSettings: boolean;
  loadingUpdateBranchSettings: boolean;
  errorBranchSettings: string | null;
  errorUpdateBranchSettings: string | null;
  userDefaults: UserDefaults | null;
  loadingLocalSettings: boolean;
  errorLocal: string | null;
  serverStatus: ServerStatusPayload | null;
}

const initialState: SettingsState = {
  branchSettings: null,
  loadingBranchSettings: false,
  loadingUpdateBranchSettings: false,
  errorBranchSettings: null,
  errorUpdateBranchSettings: null,
  userDefaults: null,
  loadingLocalSettings: false,
  errorLocal: null,
  serverStatus: null,
};

export const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    setLoadingBranchSettings(state) {
      state.loadingBranchSettings = true;
      state.errorBranchSettings = null;
    },
    setLoadingUpdateBranchSettings(state) {
      state.loadingUpdateBranchSettings = true;
      state.errorUpdateBranchSettings = null;
    },
    setErrorBranchSettings(state, action: PayloadAction<string | null>) {
      state.loadingBranchSettings = false;
      state.errorBranchSettings = action.payload;
    },
    setErrorUpdateBranchSettings(state, action: PayloadAction<string | null>) {
      state.loadingUpdateBranchSettings = false;
      state.errorUpdateBranchSettings = action.payload;
    },
    setBranchSettings(state, action: PayloadAction<BranchSettingsResponseDto>) {
      state.loadingBranchSettings = false;
      state.branchSettings = action.payload;
    },
    updateBranchSettingsSuccess(
      state,
      action: PayloadAction<BranchSettingsResponseDto>,
    ) {
      state.loadingUpdateBranchSettings = false;
      state.branchSettings = action.payload;
    },
    // --- Local (Electron Store) Reducers ---
    setLoadingLocalSettings(state, action: PayloadAction<boolean>) {
      state.loadingLocalSettings = action.payload;
    },
    setLocalError(state, action: PayloadAction<string | null>) {
      state.errorLocal = action.payload;
    },
    setUserDefaults(state, action: PayloadAction<UserDefaults>) {
      state.userDefaults = action.payload;
      state.loadingLocalSettings = false;
    },
    setServerStatus(state, action: PayloadAction<ServerStatusPayload | null>) {
      state.serverStatus = action.payload;
    },
    resetSettings: (state) => {
      state.userDefaults = FACTORY_USER_DEFAULTS;
      state.loadingLocalSettings = false;
    },
  },
});

export const settingsActions = settingsSlice.actions;
export default settingsSlice.reducer;
